"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSearch = void 0;
var queryString = require("query-string");
var merge_query_string_1 = require("./merge-query-string");
var updateSearch = function (_a) {
    var history = _a.history, navigate = _a.navigate, location = _a.location, newParams = _a.newParams, paramsFilter = _a.paramsFilter, _b = _a.newState, newState = _b === void 0 ? {} : _b, _c = _a.replace, replace = _c === void 0 ? false : _c, queryCombiner = _a.queryCombiner;
    var query;
    if (typeof queryCombiner === 'function') {
        query = queryCombiner(queryString.parse(location.search), typeof newParams === 'string' ? queryString.parse(newParams) : newParams);
        query = queryString.stringify(query);
    }
    else {
        query = (0, merge_query_string_1.mergeQueryString)(location.search, newParams, paramsFilter);
    }
    if (navigate) {
        navigate("".concat(location.pathname, "?").concat(query), { replace: replace, state: newState });
    }
    else {
        var method = replace ? 'replace' : 'push';
        history[method]({ pathname: location.pathname, search: query, state: newState });
    }
};
exports.updateSearch = updateSearch;
//# sourceMappingURL=update-search.js.map